import WidgetSettings from '@/views/Settings/Apps/Widget.vue';
import flagKeys from '@/constants/flagKeys';
import { loyaltyWidgetValidator } from '@/router/validators/navbar';

import { Route } from '../route.model';

const loyaltyWidget = new Route(
  '/loyalty-widget',
  'settings-widget',
  WidgetSettings,
  {
    isResponsive: flagKeys.responsiveDashboard,
    requiresAuth: true,
    onlyManager: true,
    validator: () => loyaltyWidgetValidator(),
    zendesk: {
      mobile: {
        offsetHorizontal: '4px',
        offsetVertical: '4px'
      }
    },
    navbar: {
      name: 'Rewards Widget', // TODO apply i18n
      icon: 'loyalty-widget',
      description:
        'Engage members online by activating a customized rewards Widget for your website.'
    },
    warnChanges: true,
    pageView: {
      eventLabel: 'Rewards Widget'
    }
  }
);

export { loyaltyWidget };
export default loyaltyWidget;
